import { ButtonTheme, variants } from './types'
import { darkColors } from '../../theme/colors'

const { PRIMARY, SECONDARY, TERTIARY, TEXT, DANGER, SUBTLE, SUCCESS } = variants

export const light: ButtonTheme = {
  [PRIMARY]: {
    background: darkColors.primary,
    backgroundActive: darkColors.secondary,
    backgroundHover: darkColors.secondary,
    border: 0,
    borderColorHover: 'currentColor',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: '#FFFFFF',
  },
  [SECONDARY]: {
    background: darkColors.secondary,
    backgroundActive: darkColors.secondary,
    backgroundHover: darkColors.secondary,
    border: `2px solid ${darkColors.primary}`,
    borderColorHover: darkColors.primaryBright,
    boxShadow: 'none',
    boxShadowActive: 'none',
    color: darkColors.primary,
  },
  [TERTIARY]: {
    background: darkColors.tertiary,
    backgroundActive: darkColors.secondary,
    backgroundHover: darkColors.secondary,
    border: 0,
    borderColorHover: 'currentColor',
    boxShadow: 'none',
    boxShadowActive: 'none',
    color: darkColors.primary,
  },
  [TEXT]: {
    background: 'transparent',
    backgroundActive: darkColors.secondary,
    backgroundHover: darkColors.secondary,
    border: 0,
    borderColorHover: 'currentColor',
    boxShadow: 'none',
    boxShadowActive: 'none',
    color: darkColors.primary,
  },
  [DANGER]: {
    background: darkColors.failure,
    backgroundActive: '#D43285', // darkten 10%
    backgroundHover: '#FF65B8', // lighten 10%
    border: 0,
    borderColorHover: 'currentColor',
    boxShadow: 'none',
    boxShadowActive: 'none',
    color: '#FFFFFF',
  },
  [SUBTLE]: {
    background: darkColors.textSubtle,
    backgroundActive: `${darkColors.textSubtle}D9`, // 70% opacity
    backgroundHover: `${darkColors.textSubtle}B3`, // 85% opacity
    border: 0,
    borderColorHover: 'currentColor',
    boxShadow: 'none',
    boxShadowActive: 'none',
    color: '#FFFFFF',
  },
  [SUCCESS]: {
    background: darkColors.success,
    backgroundActive: `${darkColors.success}D9`, // 70% opacity
    backgroundHover: `${darkColors.success}B3`, // 85% opacity
    border: 0,
    borderColorHover: 'currentColor',
    boxShadow: 'none',
    boxShadowActive: 'none',
    color: '#FFFFFF',
  },
}

export const dark: ButtonTheme = {
  [PRIMARY]: {
    ...light.primary,
  },
  [SECONDARY]: {
    ...light.secondary,
  },
  [TERTIARY]: {
    ...light.tertiary,
    background: darkColors.tertiary,
    backgroundActive: darkColors.tertiary,
    backgroundHover: darkColors.tertiary,
    color: darkColors.primary,
  },
  [TEXT]: {
    ...light.text,
    backgroundHover: darkColors.tertiary,
  },
  [DANGER]: {
    ...light.danger,
  },
  [SUBTLE]: {
    ...light.subtle,
  },
  [SUCCESS]: {
    ...light.success,
  },
}
